import styled from 'styled-components';
import { Column, Row } from '@components/LinearLayout';

export const IconsSectionContainer = styled.div`
  padding: 7.5rem 0;
  background: white;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1080}) {
    padding: 3rem 2rem;
  }
`;

export const IconsRow = styled(Row)`
  padding: 2.2rem 4rem;
  gap: 4rem;
  justify-content: center;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1080}) {
    flex-wrap: wrap;
    gap: 1rem;
    padding: 0;
    & > * {
      flex: 0 0 calc(50% - 0.5rem);
      max-width: calc(50% - 0.5rem);
    }
  }
`;

export const IconCard = styled.div`
  padding: 3.1rem;
  box-shadow: 0px 7px 16px 3px rgba(76, 92, 102, 0.05);
  background: white;
  border-radius: 1.1rem;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1080}) {
    padding: 1.5rem;
  }
`;

export const IconCardContent = styled(Column)`
  gap: 1.5rem;
  justify-content: center;
  align-items: center;
`;

export const IconCircle = styled.div`
  width: 10rem;
  height: 10rem;
  background: ${({ theme }) => theme.color.primary};
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2.5rem;
`;

export const IconImage = styled.img`
  width: 5rem;
  height: 5rem;
`;

export const TextContainer = styled(Column)`
  gap: 0.7rem;
  justify-content: center;
  align-items: center;
`;

export const CountText = styled.h4`
  font-family: proxima-nova, sans-serif;
  font-size: 3.4rem;
  font-style: normal;
  font-weight: 900;
  line-height: 115%;
  color: ${({ theme }) => theme.color.primary};
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1080}) {
    font-size: 2.5rem;
  }
`;

export const DescriptionText = styled.p`
  font-family: proxima-nova, sans-serif;
  font-size: 2rem;
  font-style: normal;
  font-weight: 800;
  line-height: 140%;
  color: ${({ theme }) => theme.color.mobilityGrey};
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1080}) {
    font-size: 1.6rem;
  }
`;
